export default "__VITE_ASSET__BDI_xOEk__"